import { createContext, useState, useContext } from 'react'
import { LoadingContext } from '../../../M_Components'

export const GenericEntityContext = createContext(null)

export const GenericEntityProvider = ({ children, canAdmin, entityPermissions }) => {
    const loadingCtx = useContext(LoadingContext)
    const [entities, setEntities] = useState([])
    const [selectedEntity, setSelectedEntity] = useState(null)

    const showError = (message) => {
        loadingCtx.toastMessages('error', message, 'Error: ')
    }

    const showSuccess = (message) => {
        loadingCtx.toastMessages('success', message, 'Success: ')
    }

    const showWarning = (message) => {
        loadingCtx.toastMessages('warning', message, 'Warning: ')
    }

    const showInfo = (message) => {
        loadingCtx.toastMessages('info', message, 'Info: ')
    }

    const hasPermission = (permission) => {
        return entityPermissions?.[permission] === true
    }

    return (
        <GenericEntityContext.Provider value={{
            entities,
            setEntities,
            selectedEntity,
            setSelectedEntity,
            canAdmin,
            entityPermissions,
            hasPermission,
            showError,
            showSuccess,
            showWarning,
            showInfo
        }}>
            {children}
        </GenericEntityContext.Provider>
    )
}

export const useGenericEntityContext = () => {
    const context = useContext(GenericEntityContext)
    if (!context) {
        throw new Error('useGenericEntityContext must be used within GenericEntityProvider')
    }
    return context
}
